__turbopack_context__.v({
  "className": "noto_sans_78004080-module__5XMYma__className",
});
